// extracted by mini-css-extract-plugin
export default {"errorBoxContainer":"ErrorBox_errorBoxContainer__TIv12","errorBoxWrapper":"ErrorBox_errorBoxWrapper__Gq4Xb","iconContainer":"ErrorBox_iconContainer__4+f9f"};